import './preview-img.scss';
import React from 'react';

const PreviewImg = ({smallImgUrl, bigImgUrl}) => {
    if (smallImgUrl) {
        return (
            <div className="preview-img">
                <div className="img-thumbnail" style={{backgroundImage:`url(${smallImgUrl})`}}/>
                <div className="big-img">
                    <img src={bigImgUrl}/>
                </div>
            </div>
        );
    }

    return null;
};

export default PreviewImg;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/preview_img/PreviewImg.js